import { Component, OnInit } from '@angular/core';
import { CalendarItemEditComponent } from '../calendar-item-edit/calendar-item-edit.component';
import { MatDialog } from '@angular/material/dialog';
import { CalendarItemService, CalendarItem, CalendarItemSummary } from '../../services/calendar-item.service';
import { CalendarItemHyperlinkService } from '../../services/calendar-item-hyperlink.service';

@Component({
  selector: 'app-calendar-item',
  templateUrl: './calendar-item.component.html',
  styleUrls: ['./calendar-item.component.css']
})
export class CalendarItemComponent implements OnInit {

  public isLoading: boolean;
  public entities: any[];
  public search: string;

  constructor(
    public dialog: MatDialog,
    public calendarItemSvc: CalendarItemService
  ) { }

  ngOnInit() {
    this.loadEntities();
  }

  private loadEntities() {
    this.isLoading = true;
    this.entities = [];
    this.calendarItemSvc.loadEntites().then(
      s=> {
        this.PrepareSearch(s);

        this.entities = s;
        console.log(s);
        this.isLoading = false;
      }
    ).catch(
      s=> {
        console.log("ERR", s);
        this.isLoading = false;
      }
    );
  }

  private PrepareSearch(items: any[]): void {
   
    items.forEach(item => {
       
      var availableSearchTerms: string[] = []; 
  
      // Set search terms for angular
      availableSearchTerms.push(item.Name);
      availableSearchTerms.push(item.Description);
      availableSearchTerms.push(item.RecurringDescription);
  
      item.AvailableSearchTerms = availableSearchTerms; 
    });
  
  }

  public add() {
    var modal = this.dialog.open(CalendarItemEditComponent); 
    modal.componentInstance.LoadItem(null);

    modal.afterClosed().subscribe((savedItem: any) => {
      console.log("modal closed", savedItem);
      if (savedItem !== undefined) {
        this.loadEntities();
      }
    });
  }

  public edit(item: CalendarItemSummary) 
  {
    var modal = this.dialog.open(CalendarItemEditComponent); 
    modal.componentInstance.LoadItem(item.Id);

    modal.afterClosed().subscribe((savedItem: any) => {
      console.log("modal closed", savedItem);
      if (savedItem !== undefined) {
        this.loadEntities();
      }
    });

  }

  public delete(item: CalendarItemSummary) 
  {
    if (confirm("Are you sure you want to delete this calendar item") == false) {
      return;
    }
    
    this.calendarItemSvc.delete(item.Id).then(
      s=> {  
        this.loadEntities();
        console.log("Deleted", s); 
      }
    ).catch(
      s=> {
        console.log("ERR", s);
        this.isLoading = false;
      }
    ); 
  }

}
